// import axios from "axios";
import { b64utoutf8, KJUR } from "jsrsasign";
import Cookies from "js-cookie";

// These are functions that have to exist outside of any state/vue object being active
// e.g. in beforeRouteEnter
export const helper = {
  // TODO:  replace this with an API call:
  STUB_verifyToken(token) {
    return KJUR.jws.JWS.verifyJWT(token, "lOaws60p4xrn1aQ6mlp9uIniyk5fjTb7", {
      alg: ["HS256"],
    });
  },
  // TODO: replace with API call
  processToken(token) {
    // axios
    // .post("/System/Config/MQ")
    // .then(response => {

    // })
    // .catch(error => {
    //   console.log(error); // TODO: handle error
    // });
    if (this.STUB_verifyToken(token)) {
      const jsonToken = KJUR.jws.JWS.readSafeJSONString(
        b64utoutf8(token.split(".")[1])
      );
      helper.setUserCookie(jsonToken);
    } else {
      // nullify any existing token:
      helper.deleteUserCookie();
    }
  },
  deleteUserCookie() {
    Cookies.remove("mqUser");
  },
  setUserCookie(newCookie, retentionPeriod = "") {
    Cookies.set("mqUser", newCookie, {
      expires:
        !retentionPeriod || retentionPeriod == ""
          ? 1
          : parseInt(retentionPeriod),
    }); //Defaulted to 1 day
  },
  getUserCookie() {
    return Cookies.getJSON("mqUser");
  },
  getCaseCookie() {
    var caseCookie = Cookies.getJSON("CaseCookie");
    return caseCookie == null || caseCookie.UserKey != helper.getUserKey()
      ? null
      : caseCookie;
  },
  getUserKey() {
    let userCookie = helper.getUserCookie();
    return userCookie ? userCookie.mobile + userCookie.userName : "";
  },
  setCaseCookie(
    caseId,
    isForAppointment,
    unitName,
    classificationName,
    retentionPeriod = ""
  ) {
    Cookies.set(
      "CaseCookie",
      JSON.stringify({
        UserKey: helper.getUserKey(),
        CaseId: caseId,
        IsForAppointment: isForAppointment,
        UnitName: unitName,
        classificationName: classificationName,
      }),
      {
        expires:
          !retentionPeriod || retentionPeriod == ""
            ? 1
            : parseInt(retentionPeriod),
      } //Defaulted to 1 day
    );
  },
  deleteCaseCookie() {
    Cookies.remove("CaseCookie");
  },
};
